import { useState, useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import { TopBar } from "../components/layout/TopBar";
import { NavRibbon } from "../components/layout/NavRibbon";
import { Footer } from "../components/layout/Footer";
import { ReceiptTracker } from "../components/views/ReceiptTracker";
import { BouncedOrders } from "../components/views/BouncedOrders";
import { InvoicesManager } from "../components/views/InvoicesManager";
import { BatchesManager } from "../components/views/BatchesManager";
import { UsersSettings } from "../components/views/settings/UsersSettings";
import { XeroConnector } from "../components/views/settings/XeroConnector";
import { NetcashConnector } from "../components/views/settings/NetcashConnector";
import { OrganizationSettings } from "../components/views/settings/OrganizationSettings";
import { NotificationSettings } from "../components/views/settings/NotificationSettings";

export default function Dashboard() {
  const { user } = useAuth();
  const [active, setActive] = useState("invoices");

  const navigate = useCallback((id) => setActive(id), []);

  const render = () => {
    switch (active) {
      case "receipt-tracker": return <ReceiptTracker />;
      case "bounced-orders": return <BouncedOrders />;
      case "invoices": return <InvoicesManager onGoToBatches={() => setActive("batches")} />;
      case "batches": return <BatchesManager />;
      case "settings:users": return <UsersSettings />;
      case "settings:xero": return <XeroConnector />;
      case "settings:netcash": return <NetcashConnector />;
      case "settings:organization": return <OrganizationSettings />;
      case "settings:notifications": return <NotificationSettings />;
      default: return <InvoicesManager onGoToBatches={() => setActive("batches")} />;
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-slate-50 dark:bg-slate-950">
      <TopBar />
      <NavRibbon active={active} onNavigate={navigate} isAdmin={user?.role === "admin"} />
      <main className="flex-1 w-full max-w-[1400px] mx-auto px-3 sm:px-6 py-6 sm:py-8" data-testid="main-content">
        {render()}
      </main>
      <Footer />
    </div>
  );
}
